import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function TomosSection() {
  const tomos = [{
    icon: '🔍',
    subtitle: 'Diagnóstico y Carga',
    desc: 'Aprendés a leer las señales de tu cuerpo antes de que se conviertan en lesión. Incluye el Semáforo del Dolor: el sistema más simple para saber cuándo acelerar y cuándo frenar. Dejás de adivinar.',
    color: 'from-[#22c55e]/10 to-transparent',
    border: 'border-t-[#22c55e]'
  }, {
    icon: '⏱️',
    subtitle: 'Estructura Sub-60',
    desc: 'El microciclo de 3 días que destruye el mito del volumen basura y te enseña a entrenar por calidad, no por cantidad. Cada sesión con un propósito claro. Adaptación climática para Argentina.',
    color: 'from-[#4ade80]/10 to-transparent',
    border: 'border-t-[#4ade80]'
  }, {
    icon: '🦵',
    subtitle: 'Biomecánica Anti-Impacto',
    desc: 'La corrección técnica que multiplica tu eficiencia y reduce el impacto articular. Cadencia correcta, postura real y propulsión inteligente. Corrés más rápido gastando menos energía.',
    color: 'from-[#16a34a]/10 to-transparent',
    border: 'border-t-[#16a34a]'
  }, {
    icon: '🥗',
    subtitle: 'Nutrición y Recobro',
    desc: 'El protocolo de recuperación nocturna y el combustible de bajo costo para el corredor argentino real. Sin suplementos caros. Tu cuerpo se recupera mientras dormís.',
    color: 'from-[#15803d]/10 to-transparent',
    border: 'border-t-[#15803d]'
  }, {
    icon: '💪',
    subtitle: 'Fuerza Blindada',
    desc: 'Rutinas de 15 minutos para casa o parque que construyen la musculatura que protege tus articulaciones y dispara tu rendimiento. Más potencia, menos dolor, más kilómetros sin deterioro.',
    color: 'from-[#22c55e]/10 to-transparent',
    border: 'border-t-[#22c55e]'
  }, {
    icon: '📅',
    subtitle: 'El Plan Maestro',
    desc: 'El cronograma anual sin fechas fijas adaptable a tu vida real, más el checklist completo de preparación de carrera. Dejás de improvisar para siempre. Tenés un mapa claro de todo el año.',
    color: 'from-[#4ade80]/10 to-transparent',
    border: 'border-t-[#4ade80]'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-6xl mx-auto" data-id="element-366">
      <FadeIn data-id="element-367">
        <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] text-center mb-6 md:mb-14 flex items-center justify-center gap-3 md:gap-4" data-id="element-368">
          <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(34,197,94,0.3)]" data-id="element-369">
            📚
          </span>{' '}
          LOS 6 TOMOS
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-370">
        {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-371">
            <motion.div whileHover={{
          y: -5,
          scale: 1.02
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} className={`bg-white border border-[#e2e8f0] ${tomo.border} border-t-4 hover:border-[#22c55e] transition-all rounded-2xl p-4 md:p-8 h-full flex flex-col relative overflow-hidden shadow-sm hover:shadow-xl`} data-id="element-372">
              <div className={`absolute inset-0 bg-gradient-to-b ${tomo.color} opacity-50 pointer-events-none`} data-id="element-373"></div>

              <div className="absolute top-3 right-3 md:top-4 md:right-4 text-[10px] md:text-xs font-black tracking-widest text-[#16a34a] bg-[#f8fafc] px-2 py-0.5 md:px-3 md:py-1 rounded-full border border-[#e2e8f0]" data-id="element-374">
                TOMO 0{index + 1}
              </div>

              <div className="text-4xl md:text-6xl mb-3 md:mb-6 relative z-10 drop-shadow-sm" data-id="element-375">
                {tomo.icon}
              </div>

              <h3 className="text-lg md:text-xl font-black text-[#0f172a] mb-1.5 md:mb-2 relative z-10" data-id="element-376">
                {tomo.subtitle}
              </h3>

              <p className="text-sm md:text-base text-[#475569] font-medium leading-relaxed flex-grow relative z-10" data-id="element-377">
                {tomo.desc}
              </p>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}